import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ShorterPipe } from './shorter.pipe'

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ShorterPipe
  ],
  exports: [
    ShorterPipe
  ]
})
export class UtilsModule { }



// WEBPACK FOOTER //
// ./src/app/shared/utils/utils.module.ts